import { render } from "./Concessions.vue?vue&type=template&id=92f8c4da"
import script from "./Concessions.vue?vue&type=script&lang=js"
export * from "./Concessions.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__